import { ROUTES } from '@constants'

import type { RouteStrategy, RouteStrategyParams } from './routeStrategy'

export class TimelineRoute implements RouteStrategy {
  public getRedirectPath(params: RouteStrategyParams): string | undefined {
    const { code } = params

    if (!code) {
      console.warn('Code is required to redirect to config')

      return
    }

    return `${ROUTES.TIME_LINE_GRID_EDIT}/${code}?cameFrom=${ROUTES.TIME_LINE_GRID_SHOW.replace(
      ':id',
      code
    )}`
  }
}
